import { Box, Typography } from '@mui/material';
import noEvents from '../../../../Assets/NoEventImage.jpg';
import logo from '../../../../Assets/in5-logo.png';

export default function KenApplicationFormHeader(props) {
  const { form } = props;

  return (
    <Box
      component={'div'}
      height={'180px'}
      sx={{
        backgroundImage: `url('${form?.program.bannerImage ? form?.program.bannerImage : noEvents}')`,
        backgroundPosition: '50% 20%',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        borderRadius: '12px 12px 0px 0px',
      }}
      className="Event-header"
    >
      <Box component={'div'} bgcolor={'rgba(0, 0, 0, 0.30)'} className="p-5 d-flex justify-content-start align-items-center" borderRadius={'12px 12px 0px 0px'} height={'180px'} width={'100%'}>
        <Box component={'div'} sx={{ marginLeft: '80px' }} className="d-flex flex-column" gap={'12px'}>
          <Box component={'img'} src={logo} sx={{ height: '62px', width: 'max-content' }} />
          <Box component={'div'} className="d-flex flex-column" gap={'4px'}>
            <Typography
              sx={{
                background: 'linear-gradient(179.47deg, #FFFFFF 30.8%, rgba(229, 230, 232, 0) 123.48%)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent',
              }}
              variant="largemedium"
            >
              {form?.formName}
            </Typography>
            {/* <Typography color={'#FFFFFF'} variant="smallmedium">
              Apply Before {form?.endDate}
            </Typography> */}
          </Box>
        </Box>
      </Box>
    </Box>
  );
}
